import { StatModule } from "@/core/modules/stat/objects/StatModule";

import HandleChartView from "./views/HandleChartView.vue";

export const handleChart: StatModule = new StatModule("warehouse", "HandleChart", "warehouseStat", HandleChartView);
